<label class="container" [class.label-after]="after" [class.block]="block">
	<span class="label">
		<ng-content></ng-content>
	</span>
	<div class="switch">
		<input type="checkbox" [(ngModel)]="checked" (change)="toggled.emit(checked)" />
		<span class="slider"></span>
	</div>
</label>
